"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SiteFooter = void 0;
const react_1 = __importDefault(require("react"));
const SiteFooter = ({ className, children, testing }) => {
    return (react_1.default.createElement("div", { className: `mt-24 w-full border-t border-slate-2 ${className}`, "data-testid": testing && 'footer-wrapper' },
        react_1.default.createElement("div", { className: "container mx-auto px-5 lg:px-0" },
            react_1.default.createElement("div", { className: "py-10" }, children),
            react_1.default.createElement("div", { className: "border-t border-slate-2 pt-4 pb-16" },
                "\u00A9 Copyright ",
                new Date().getFullYear(),
                ", Cluey Learning"))));
};
exports.SiteFooter = SiteFooter;
